// @flow

export default {
  containPicture: {
    borderRadius: '50%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
  },
};
